export function canAccessScreenShareAction({ screenShareConfigEnabled = true, canSpawnAndMoveMedia = false } = {}) {
  return !!screenShareConfigEnabled && !!canSpawnAndMoveMedia;
}

export function shouldShowScreenShareAction({
  screenShareConfigEnabled = true,
  canSpawnAndMoveMedia = false,
  canShareScreen = false,
  isSharingScreen = false,
  screenShareHidden = false,
  isMobile = false
} = {}) {
  if (isMobile || screenShareHidden) {
    return false;
  }

  if (!canAccessScreenShareAction({ screenShareConfigEnabled, canSpawnAndMoveMedia })) {
    return false;
  }

  return isSharingScreen || canShareScreen;
}
